export default __webpack_public_path__ + "static/media/netflix.fa03b0c1.png";